import React from 'react';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
;

// Need to put the id in this paramater, and put it in the triggerUpdateInparent first paramter, not on the field itself
export default function YesOrNoCheckbox(props) {
  var once = false;
  const [v_state, setVState] = React.useState({
    mainState: false,
    yesState: props.valueInField,
    noState: !props.valueInField
  });
  var state = {
    yesState: false,
    noState: false,
    mainState: false
  }

  function setState(yes, no, main){
    state.yesState = yes;
    state.noState = no;
    state.mainState = main;
    setVState({yesState: state.yesState, noState: state.noState, mainState: state.mainState})
  }

  /*if (props.id == "consentToEvalAttached_bill"){
    if (!once){
      // Once
      once = true;
      if (props.valueInField == true){
        setState(true, false, true)
      }
      else{
        setState(false, true, false)
      }
    }

  }*/

  const handleChangeYes = (event) => {
  };
  const handleChangeNo = (event) => {
  };

  const handleClickYes = (event) =>{
    setState(true, false, true);
    if (props.triggerUpdateInParent){
      //props.triggerUpdateInParent(props.id, event.target.checked)
      props.triggerUpdateInParent(props.id, state.mainState)
      //alert("Is check inside: " + state.checked)
    }
    if (props.renderOther) props.renderOther(true);
  }
  const handleClickNo = (event) =>{
      setState(false, true, false);
    if (props.triggerUpdateInParent){
      //props.triggerUpdateInParent(props.id, event.target.checked)
      props.triggerUpdateInParent(props.id, state.checked)
      //alert("Is check inside: " + state.checked)
    }
    if (props.renderOther) props.renderOther(false);
  }

  return (
    <FormGroup row>
      {props.required ? <span className="required-field-checkbox">*</span> : <span className="unrequired-field">*</span>}
      <span className={props.classesToAdd}></span>
      <span style={{paddingTop: '8px', paddingRight: '4px'}}>{props.altLabel1 ? props.altLabel1 : "No"}</span>
            {/*<FormControlLabel
              control={*/}
                <Checkbox
                  id={props.noId}
                  checked={v_state.noState}
                  onChange={handleChangeNo}
                  onClick={handleClickNo}
                  name="checked"
                  color="primary"
                />
              {/*}
              label={props.label}
            />*/}

        <span style={{paddingTop: '8px', paddingRight: '4px'}}>{props.altLabel2 ? props.altLabel2 : "Yes"}</span>
      {/*<FormControlLabel
        control={*/}
          <Checkbox
            id={props.yesId}
            checked={v_state.yesState}
            onChange={handleChangeYes}
            onClick={handleClickYes}
            name="checked"
            color="primary"
          />
        {/*}
      label={props.label}
      />*/}
      
    </FormGroup>
  );
}
